import { type ActionItem, toastStore } from 'shared/ui'
import { writeTextToClipboard } from 'shared/lib'
import { type RowInvite } from 'entities/Users/model/Table/RowInvite'

export const copyInviteLink = (
  invite: RowInvite,
  onSuccess?: () => void | Promise<void>
): ActionItem => {
  return {
    text: 'Copy invite link',
    icon: 'copy',
    onAction: () => {
      writeTextToClipboard(invite.url)

      toastStore.add({
        type: 'info',
        title: 'Copied',
      })

      onSuccess?.()
    },
  }
}
